import React, { Component } from 'react';
import toastr, { success } from 'toastr';
import objectToFormdata from 'object-to-formdata';
import Loadable from 'react-loading-overlay';
import urlParse from 'url-parse';
import reactWindowSize from 'react-window-size';
import 'video-react/dist/video-react.css';
import apiClient from '../util/api-client';
import ListFileErrors from './ListFileError';
import { reload as reloadActivities } from './ActivitiesButton';
import { Progress } from 'reactstrap';
import axios from 'axios';
import UploadSection from './UploadSection';
import FileTable from './FileTable';
import { ALLOWED_FILE_TYPES } from '../util/common';
import * as MultipartUpload from '../util/multipart-upload';


const _getCurrentUrl = () => new URL(location.href);
const url = { get searchParams() { return _getCurrentUrl().searchParams; } };

const ONE_GB_TO_BYTES = Math.pow(2,30);
const PLANS = ['free', 'minimum', 'basic', 'master']
const PLANS_TEXT = ['無料','ミニマム','ベーシック','マスター']
const REGEXP_URL = /projects\/(\d+)\/(\d+)\/akaire\/(\S)/
const TICKET_REGEXP_URL = /projects\/(\d+)\/(\d+)\/(\d+)\/akaire\/(\S)/
const MAX_FILES = 30;
const csrfTokenTag = document.querySelector('meta[name="csrf-token"]');

class NewMultipleAkaireFiles extends Component {
  constructor(props) {
    super(props);
    const { id, baseURL, last_page_id, is_create_video_embed, is_create_pass_video, current_total_size } = props;
    this.props = { ...this.props, ...props };
    this.state = {
      isDisableUpload: true,
      captureMode: 'separate',
      dragIndex: null,
      files: [],
      numberShowFile: 10,
      fileErrors: [],
      fileUploadErrors: [],
      fileUploadSuccess: [],
      user: {},
      project: {},
      loadingText: null,
      percentComplete: 0,
      animations: [],
      markers: [],
      pages: [],
      currentAnimationId: null,
      currentPageId: last_page_id,
      assignments: [],
      shouldShowGetUrlModal: false,
      shouldShowProjectShareModal: false,
      shouldShowProjectFormModal: false,
      shouldShowAnimationUploaderModal: false,
      shouldShowAnimationUploaderImageModal: false,
      shouldShowCompletionModal: false,
      shouldShowPublicUrlModal: false,
      shouldShowGetUrlYoutube: false,
      isLoading: false,
      activeTab: 'markers',
      timerCheckAnimation: null,
      responseConvertVideo: null,
      timerDownloadExtensionFile: null,
      downloadExtensionUrl: null,
      convertFile: false,
      completed: 0,
      finishConvert: false,
      changeCss: false,
      uploadedDataInfo: {},
      isNewAnimationCreated: false,
      membersInComment: [],
      animationSelectCurrent: null,
      is_create_video_embed: is_create_video_embed,
      is_capture_video_youtube: false,
      is_cancel_capture_video_youtube: false,
      isShowFullscreenAnimation: false,
      is_create_pass_video: is_create_pass_video,
      isShowInputPassVideo: false,
      passwordShareVideo: '',
      isDisabledButtonSavePass: true,
      isShowInputDemo: false,
      currentPasswordShareVideo: '',
      currentTotalSize: current_total_size,
      showProgressBar: false,
      convert_file: false,
      nameLastFile: '',
    };
    this.currentURL = baseURL;
    this.baseURL = baseURL
    this.apiClient = apiClient({ baseURL: this.baseURL });
    this.apiClientGetLink = axios.create({
      headers: {
        'X-CSRF-TOKEN': csrfTokenTag && csrfTokenTag.getAttribute('content') || '',
        'Accept': 'application/json'
      },
    });
    this.multipartApiClient = apiClient({ baseURL: '/' });
    this.concurrentUploads = 3;
    this.percentConvert = null;
  }

  componentDidUpdate(_, prev) {
    const { is_cancel_capture_video_youtube, is_capture_video_youtube } = this.state;
    if (is_cancel_capture_video_youtube && is_capture_video_youtube !== prev.is_capture_video_youtube &&
      is_capture_video_youtube === false && prev.is_capture_video_youtube === true) {
      this.setState({is_cancel_capture_video_youtube: false})
    }
  }

  toggleElementList(className, show = true) {
    const elementList = document.getElementsByClassName(className);
    for (let i = 0; i < elementList.length; i ++) {
      elementList[i].style.visibility = show ? "visible" : "hidden";
    }
  }

  currentAnimation = () => this.state.animations.find(_ => _.id === this.state.currentAnimationId)
  fromProjectId = () => {
    return url.searchParams.get('from_project_id');
  }
  fromTaskId = () => {
    return url.searchParams.get('from_task_id');
  }
  fromWorkId = () => {
    return url.searchParams.get('from_work_id');
  }
  fromPageId = () => {
    return url.searchParams.get('from_page_id');
  }
  fromAkaireFileId = () => {
    return url.searchParams.get('from_file_id');
  }
  withNewTask = () => {
    return url.searchParams.get('with_new_task');
  }
  withNewProject = () => {
    const url = new URL(location.href);
    return url.searchParams.get('with_new_project');
  }
  withNewFile = () => {
    return new URL(location.href).searchParams.get('with_new_file');
  }
  textFor = (plan) => {
    return PLANS.indexOf(plan) >= 0 && PLANS_TEXT[PLANS.indexOf(plan)]
  }
  showAlertLimitVideo = () => {
    const {current_limit_video: currentLimitVideo, current_subscription_type: currentSubscriptionType} = this.props;
    const nextLevelPlan = this.textFor(PLANS[PLANS.indexOf(currentSubscriptionType)+1])
    const text = nextLevelPlan ? `${nextLevelPlan}プラン以上にアップグレードするか、データの圧縮をしてからアップロードをお願い致します。` : ''
    toastr.error(`${this.textFor(currentSubscriptionType)}プランの場合、1回でのアップロード制限は${currentLimitVideo}GB以内です。${text}`);
  }

  convertVideo = async (signedUrl, filename) => {
    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true'
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id')
    const convertPromise = new Promise(async (resolve, reject) => {
      while (true) {
        try {
          const res = await this.apiClient.put(
            `${pageId ? 'animations/convert_mp4' : 'convert_mp4'}`,
            {
              pathname: decodeURI(urlParse(signedUrl).pathname),
              page_id: pageId,
              filename: filename,
              from_project_id: this.fromProjectId() ,
              from_task_id: this.fromTaskId(),
              from_work_id: this.fromWorkId(),
              from_page_id: this.fromPageId(),
              from_akaire_file_id: this.fromAkaireFileId(),
              with_new_task: this.withNewTask(),
              with_new_project: this.withNewProject(),
            }) // decode the file name to the correct original name
            if (res.data.type === 'success') {
              setTimeout(() => {
                reloadActivities();
              }, 1000);
              resolve(true); // Resolve promise khi convert hoàn thành
              break; // Thoát khỏi vòng lặp
            }
            await new Promise((resolve) => setTimeout(resolve, 2000));
        } catch (error) {
          this.endLoading();
          // this.close('AnimationUploaderModal');
          reject(error);
          break;
        }
      }
    });
    const isDoneConvert = await convertPromise;
    return isDoneConvert;
  }
  file_extension = (filename) => {
    const extensions = filename.split('.').slice(-1)
    if (extensions.length) { return extensions[0].toUpperCase() }
  }

  finalizeAnimation = () => {
    const { currentAnimationId } = this.state;
    this.startLoading('Now processing...');
    return this.apiClient.post(`animations/${currentAnimationId}/finalization`)
      .then(() => {
        toastr.success('完成しました');
        // reloadActivities();
      })
      .catch(() => {
        toastr.error('完成できませんでした');
      })
      .finally(this.endLoading);
  }

  toggle = bool => name => {
    this.setState({ [`shouldShow${name}`]: bool });
    if(!bool) {
      if($('#uploadNewPagePopup').attr('data-upload-new') == 'true') {
        $('#uploadNewPagePopup').modal('show')
      } else {
        $('#uploadVersionPopup').modal('show')
      }
    }
  }
  open = this.toggle(true)
  close = this.toggle(false)

  changeURL = (item, newPage = false, idAkaire = null) => {
    let baseURL = this.props.baseURL;
    if(baseURL && baseURL.match(REGEXP_URL)) {
      let pageId = 'new';
      let versionId = 'new';
      let akareId = 'new';
      this.state.pages.map((e,i) => {
        if (item == e.id) {
          pageId = e.id;

          if (this.state.animations.length > 0 && !newPage) {
            this.state.animations.map((item, index) => {
              if (item.id === this.state.currentAnimationId) {
                versionId = item.id;
              }
            });
          }
        }
      });

      if (idAkaire) {
        akareId = idAkaire;
      }
      if (akareId == 'new' && pageId == 'new' && versionId == 'new') {
        let url = '/projects/' + baseURL.match(REGEXP_URL)[1] + '/' + baseURL.match(REGEXP_URL)[2] + '/akaire/new';
      }
      else {
        let url = '/projects/' + baseURL.match(REGEXP_URL)[1] + '/' + baseURL.match(REGEXP_URL)[2] + '/akaire/'+ akareId + '/' + pageId + '/' + versionId;
      }
      window.history.pushState( "", "", url );
    }
  }

  startLoading = (loadingText, title) => {
    this.fadeInLoader();
    $('.message_overlay').removeClass('d-none')
    this.setLoadingContent(loadingText, title)
    this.setState({ isLoading: true });
  }

  endLoading = () => {
    this.setState({ loadingText: null, isLoading: false });
    $('.preloader').fadeOut();
    clearInterval(this.percentConvert);
    this.percentConvert = null;
  }
  convertFile = (file) => this.setState({ convertFile: file })
  finishConvert = (type) => {
    this.setState({ finishConvert: type })
  }
  onSubmitCompletionModal = () => {
    this.finalizeAnimation().then(this.close.bind(this, 'CompletionModal'));
  }

  reloadAfterUpload = () => {
    if (window.Popup && window.Popup.confirm) {
      window.Popup.confirm(
        'アップロードを開始しました。<br>アップロード完了後、<br>ご登録のメールアドレス宛に完了通知が送信されます。<br><br>全てのアップロードが完了するまでお待ちください。',
        { confirmText: 'OK', cancelBtn: false, success: () => {} }
      );
    }
  }

  setLoadingContent = (message, title = null) => {
    this.setState({
      loadingText: (
        <>
          <div style={{ fontWeight: 'bold' }}><p>{title}</p></div>
          <div><p>{message}</p></div>
        </>
      )
    });
  };

  fadeInLoader = () => {
    const pageId = $('#uploadVersionPopup').attr('data-page-id')
    if(pageId) {
      $('.preloader').fadeIn();
      setInterval(() => {
        $('.preloader').css('opacity', 0.2)
      }, 200);
    }
  }

  changeFocus = () => {
    const {isShowInputDemo} = this.state
    this.setState({isShowInputDemo: !isShowInputDemo});
  }

  changeMultipleFiles = (e) => {
    const listFiles = Array.from(e.target.files)
    this.addFiles(listFiles)
  }

  handelOnDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.addFiles(Array.from(e.dataTransfer.files))
      e.dataTransfer.clearData();
    }
  }

  isFileBigSize = (file) => {
    const { limit_upload_video: limitUploadVideo } = this.props;
    if (!!limitUploadVideo) {
      return file.size > limitUploadVideo.size;
    }
  }

  // check file type, allow only video file
  isFileTypeNotAllow = (file) => {
    return !ALLOWED_FILE_TYPES.includes(file.type);
  }

  addFiles = (files) => {
    const listFileErrors = Array.from(this.state.fileErrors)
    let isErrors = false
    const validFiles = files.filter((file) => {
      if (this.isFileBigSize(file) || this.isFileTypeNotAllow(file)) {
        const isPresent = listFileErrors.find((f) => file.name === f.name && f.size === file.size)
        if (!isPresent) listFileErrors.push(file);
        isErrors = true
        return false;
      }
      return true;
    });
    if (isErrors) this.setState({ [`shouldShowGetUrlModal`]: true });
    this.setState({ fileErrors: listFileErrors })


    if (this.state.files.length + validFiles.length > MAX_FILES) {
      Popup.alert('まとめアップロードは30件までです。');
      return; // Stop adding files if the limit is reached
    }

    const uniqueFiles = validFiles.filter((newFile) => {
      return !this.state.files.some((existingFile) => existingFile.name === newFile.name && existingFile.size === newFile.size);
    });

    this.setState({files: [...this.state.files, ...uniqueFiles]});
    if (this.state.files.length + uniqueFiles.length > 0) {
      this.setState({isDisableUpload: false});
    }
  };

  setDragIndex = (index) => {
    this.setState({ dragIndex: index });
  }
  handleReorderFile = (toIndex) => {
    const { dragIndex } = this.state;
    if (dragIndex === null || dragIndex === toIndex) {
      this.setState({ dragIndex: null });
      return;
    }
    const newFiles = [...this.state.files];
    const [moved] = newFiles.splice(dragIndex, 1);
    newFiles.splice(toIndex, 0, moved);
    this.setState({ files: newFiles, dragIndex: null });
  }
  handleDeleteFile = (file, index) => {
    const newListFiles = [...this.state.files];
    newListFiles.splice(index, 1);
    this.setState({files: newListFiles});
    if (newListFiles.length === 0) {
      this.setState({isDisableUpload: true});
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleUploadFiles = async (e) => {
    if (this.state.files.length === 0) {
      Popup.alert('アップロードするファイルを選択してください');
      return
    }
    const files = [...this.state.files];
    const data = {
      files: files,
      dataUpload: {
        checkUploadNewPage: $('#uploadNewPagePopup').attr('data-upload-new') == 'true',
        dataPageId: $('#uploadVersionPopup').attr('data-page-id'),
        projectId: this.fromProjectId(),
        taskId: this.fromTaskId(),
        workId: this.fromWorkId(),
        pageId: this.fromPageId(),
        is_multiple_upload: true,
        capture_mode: this.state.captureMode,
        with_new_project: this.withNewProject(),
        with_new_task: this.withNewTask(),
        with_new_file: this.withNewFile(),
        csrfTokenTag: csrfTokenTag.getAttribute('content'),
        baseURL: this.baseURL
      }
    }
    // if not support service worker then upload file by normal way (not use service worker)
    this.setState({ isDisableUpload: true });
    this.reloadAfterUpload();
  if (!!navigator.serviceWorker && navigator.serviceWorker.controller && 'SyncManager' in window) {
    navigator.serviceWorker.controller.postMessage({
      type: 'UPLOAD_FILES',
      payload: data
    });
  } else {
    if ('serviceWorker' in navigator && 'SyncManager' in window) {
      navigator.serviceWorker.ready.then(registration => {
        registration.sync.register('sync-upload-files').then(() => {
          console.log('Sync registered');
          navigator.serviceWorker.controller.postMessage({
            type: 'UPLOAD_FILES',
            payload: data
          });
        }).catch(err => {
          console.log('Sync registration failed', err);
        });
      });
    } else {
      this.startLoading(`アップロード中...`);
      const filesUploadErrors = [];
      const fileUploadSuccess = [];
      const animationIdByIndex = [];
      const uploadPromises = this.state.files.map(async (file, index) => {
        try {
          const animationId = await this.handleUploadFileToS3(file);
          fileUploadSuccess.push(file);
          if (animationId) animationIdByIndex[index] = animationId;
        } catch (e) {
          filesUploadErrors.push(file);
        }
      });
      await Promise.all(uploadPromises);
      const animationIds = animationIdByIndex.filter((id) => id != null);
      this.setState({ fileUploadErrors: filesUploadErrors });
      this.setState({ fileUploadSuccess: fileUploadSuccess });
      try {
        await this.sendMailWhenUploadMultipleFiles(filesUploadErrors, animationIds);
      } catch (e) {
        Popup.alert('アップロードプロセスは成功しましたが、メール送信プロセスでエラーが発生しました');
      }
      this.endLoading();
      if (window.Popup && window.Popup.confirm) {
        window.Popup.confirm(
          'アップロードが完了しました。<br>詳細はご登録のメールアドレスに送信されました。',
          { confirmText: 'OK', cancelBtn: false, success: () => { window.location.href = '/projects'; } }
        );
      } else {
        window.location.href = '/projects';
      }
    }
  }
  this.changeURL(this.state.currentPageId);
  }

  sendMailWhenUploadMultipleFiles = async (filesUploadErrors, animationIds = []) => {
    const listErrorNames = filesUploadErrors.map((file) => file.name)
    const listFileUploads = this.state.files.map((file) => file.name)
    const data = {
      list_errors: listErrorNames,
      list_uploads: listFileUploads,
      animation_ids: animationIds,
      capture_mode: this.state.captureMode,
      with_new_project: this.withNewProject(),
      with_new_task: this.withNewTask(),
      with_new_file: this.withNewFile(),
      data_upload: { from_project_id: this.fromProjectId(), from_task_id: this.fromTaskId() }
    }
    await this.apiClientGetLink.post(`send_upload_report_email`, data)
      .then((response) => {
      })
      .catch((error) => {
        throw new Error(error)
      })
  }

  handleUploadFileToS3 = async (file) => {
    const fileName = file.name.replace(/[^\w\d_\-.]+/ig, '');
    const type = file.type
    const onProgressCallback = (progress) => {
      this.onUploadProgress(progress);
    };

    const signedUrl = await MultipartUpload.performMultipartUpload(
      file,
      onProgressCallback,
      this.concurrentUploads,
    );

    const { url } = signedUrl;

    const checkUploadNewPage = $('#uploadNewPagePopup').attr('data-upload-new') == 'true'
    const pageId = checkUploadNewPage ? 'new' : $('#uploadVersionPopup').attr('data-page-id')
    const isConvertFile = type == 'video/x-msvideo' || type == 'video/avi' || type.includes('wmv') || type === 'video/quicktime'
    this.setState({ convert_file: isConvertFile })
    return this.apiClient.post(
      `${pageId ? 'animations' : ''}`,
      {
        pathname: decodeURI(urlParse(url).pathname),
        page_id: pageId,
        filename: fileName,
        from_project_id: this.fromProjectId(),
        from_task_id: this.fromTaskId(),
        from_work_id: this.fromWorkId(),
        from_page_id: this.fromPageId(),
        from_akaire_file_id: this.fromAkaireFileId(),
        with_new_task: this.withNewTask(),
        with_new_project: this.withNewProject(),
        is_multiple_upload: true
      })
      .then(async(response) => {
        const animationId = response && response.data && response.data.animation_id ? response.data.animation_id : null
        if (isConvertFile) {
          window.time = (((file.size / 1024) * 60000) / (40 * 1024)) + 10000
          const isDoneConvert = await this.convertVideo(url, fileName)
        }
        return animationId
      })
  }

  onUploadProgress = (percent) => {
    this.setState({ showProgressBar: true })
    if(!this.state.convert_file){
      this.setState({ completed: percent })
    }
  }

  showUpload = () => {
    $('#inputFieldFiles').click();
  }

  renderNormal() {
    const { current_user_id: currentUserId, role, id, root_url: rootUrl, statuses,
      is_free_plan: isFreePlan, current_limit_video: currentLimitVideo, token_public_url: token_public_url,
      category, is_akapon_member: isAkaponMember, is_project_owner_member, isAkaponProject, baseURL, limit_upload_video
    } = this.props;
    const {
      files, numberShowFile, captureMode, dragIndex,
      loadingText, isLoading, shouldShowGetUrlModal, completed, showProgressBar, fileErrors, isDisableUpload
    } = this.state;
    const currentAnimation = this.currentAnimation();
    const token = token_public_url;
    const public_video_token = currentAnimation && currentAnimation.url_token;
    var darkGray = 'l-container u-bg--darkGray py-3 mt-2 mt-sm-0';
    var progressBar = '';
    if (!currentAnimation) {
      darkGray = darkGray.concat(" darkGray-animation")
    }
    if (showProgressBar) {
      progressBar = (
        <Progress value={completed}>{completed}%</Progress>
      )
    }
    return (
      <div className="animation-inspector">
        <style>{`
          @media (max-width: 768px) {
            /* 白カードを全面に */
            .create-akaire-box-multiples {
              width: 100% !important;
              margin: 0 !important;
              border-radius: 0 !important;
              padding-top: 12px !important;
              padding-left: 10px !important;
              padding-right: 10px !important;
            }
            .darkGray-animation, .l-main, .pane-wrapper { padding-left: 0 !important; padding-right: 0 !important; }
            /* アイコン右の空白を詰める */
            .create-akaire-box-multiples .create-akaire-box-title-content.ml-4 { margin-left: 8px !important; }
            .create-akaire-box-multiples .create-akaire-box-title-content { margin-left: 8px !important; }
            /* 文字を小さく */
            .create-akaire-multiple-url .create-akaire-box-title-content { font-size: 18px !important; }
            .create-akaire-box-multiples .fs-title-popup-url { font-size: 15px !important; }
            .create-akaire-multiple-url .text-black { font-size: 12px !important; }
            .create-akaire-box-title-content { font-size: 17px !important; }
            .create-akaire-box-multiples, .create-akaire-box-multiples .text-black, .mc-work1, .mc-work2 { font-size: 13px !important; }
            /* 作業1/2 縦積み */
            .mc-work-row { display:block !important; padding:0 !important; max-width:100% !important; }
            .mc-work1, .mc-work2 { flex:1 1 100% !important; min-width:0 !important; width:100%; }
            .mc-work2 { border-left:none !important; padding-left:0 !important; margin-top:12px; border-top:1px dashed #c0c0c0; padding-top:12px; }
            /* テーブルを左右10pxまで広げる */
            .create-akaire-multiple-url .w-80 { width: 100% !important; }
            .create-akaire-multiple-url .border-1px-black { margin-left:0 !important; margin-right:0 !important; }
            .show-table-files { margin-left:0 !important; margin-right:0 !important; }
            /* スマホ時はグレー背景・シャドーを除外して白を全面に */
            .u-bg--darkGray { background: transparent !important; box-shadow: none !important; border-radius: 0 !important; }
            .darkGray-animation { background: transparent !important; box-shadow: none !important; }
            #upload-animation-multiple-files { background: transparent !important; }
          }
        `}</style>
        <Loadable
          className="loading-overlay"
          active={isLoading}
          zIndex={10000}
        >
          <div className="message_overlay d-none">
            { loadingText }
          </div>
          <div className={darkGray}>
            <div className="l-main">
              <div className="pane-wrapper">
                {/* アニメーション */}
                <div className='create-akaire-box-multiples text-center create-akaire-multiple-url'>
                  <UploadSection
                    handleOnDrop={this.handelOnDrop}
                    handleDragLeave={this.handleDragLeave}
                    handleDragOver={this.handleDragOver}
                    changeMultipleFiles={this.changeMultipleFiles}
                    showUpload={this.showUpload}
                  />
                  <div className='d-flex text-left mb-2 flex-wrap mc-work-row' style={{gap:'0px', alignItems:'stretch', maxWidth:'900px', margin:'0 auto', justifyContent:'flex-start', marginTop:'20px'}}>
                    <div className='mc-work1' style={{flex:'0 1 420px', minWidth:'300px'}}>
                      <div className='font-weight-bold text-black mb-1'>【作業1】このまとめアップロードの保存方法を選択してください</div>
                      <label className='d-block mb-1 cursor-pointer text-black'>
                        <input type='radio' name='captureMode' value='separate' checked={captureMode === 'separate'} onChange={() => this.setState({captureMode: 'separate'})} className='mr-2' />
                        別々のファイルにする（データごとに1ファイル）
                      </label>
                      <label className='d-block mb-0 cursor-pointer text-black'>
                        <input type='radio' name='captureMode' value='single' checked={captureMode === 'single'} onChange={() => this.setState({captureMode: 'single'})} className='mr-2' />
                        同じファイルにまとめる（1ファイルに全動画をページ追加）
                      </label>
                    </div>
                    <div className='mc-work2' style={{flex:'1 1 300px', minWidth:'260px', borderLeft:'1px dashed #c0c0c0', paddingLeft:'24px'}}>
                      <div className='font-weight-bold text-black mb-1'>【作業2】</div>
                      <label htmlFor="inputFieldFiles"
                        onDrop={this.handelOnDrop}
                        onDragLeave={this.handleDragLeave}
                        onDragOver={this.handleDragOver}
                        style={{
                          flex:'0 1 180px', minWidth:'160px', minHeight:'56px',
                          border:'2px dashed #9aa0a6', borderRadius:'8px', background:'#fff',
                          display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center',
                          padding:'8px 12px', color:'#5f6368', fontWeight:700, cursor:'pointer', marginBottom:0
                        }}>
                        データをドラッグ＆<br/>ドロップしてください。
                      </label>
                      <input type='file' id='inputFieldFiles' className='d-none'
                        accept='video/mp4,video/mov,video/avi,video/x-ms-wmv,video/quicktime,video/x-msvideo'
                        onChange={this.changeMultipleFiles} multiple />
                    </div>
                  </div>
                  {progressBar}
                  <FileTable
                    files={files}
                    handleDeleteFile={this.handleDeleteFile}
                    handleUploadFiles={this.handleUploadFiles}
                    isDisableUpload={isDisableUpload}
                    dragIndex={dragIndex}
                    setDragIndex={this.setDragIndex}
                    handleReorderFile={this.handleReorderFile}
                    onCancel={() => { window.location.href = window.location.origin + '/akaire_feature/akaires' + window.location.search }} />
                </div>
              </div>
              {/* / pane-wrapper */}
            </div>
            {/* / l-main */}
          </div>
          {/* / l-container */}


          <ListFileErrors isOpen={shouldShowGetUrlModal} onClickClose={this.close.bind(this, 'GetUrlModal')} token={token}
            rootUrl={rootUrl} files={fileErrors}
            baseURL={this.baseURL} isAkaponProject={isAkaponProject} isCreateOfTemp={true} limitUploadVideo={limit_upload_video}/>
        </Loadable>
      </div>
    )
  }

  render() {
    return this.renderNormal();
  }
}

export default reactWindowSize(NewMultipleAkaireFiles);

export { NewMultipleAkaireFiles };
